import {
  isObject,
  isEmpty,
  isNumber,
  isBoolean,
  isNaN,
  isNull,
  isUndefined
} from "lodash";

interface OTP {
  removeEmptyObject?: boolean;
  removeEmptyArray?: boolean;
  removeEmptyString?: boolean;
  removeCeroValue?: boolean;
  removeNullValue?: boolean;
  removeUndefinedValue?: boolean;
  removeFalseValue?: boolean;
  removeNaNValue?: boolean;
  oneIsTrue?: boolean;
  ceroIsFalse?: boolean;
  trueIsOne?: boolean;
  falseIsCero?: boolean;
}

const removeEmpty = (obj: any, opt: OTP) => {
  Object.keys(obj).forEach(key => {
    if (isObject(obj[key]) || Array.isArray(obj[key])) {
      removeEmpty(obj[key], opt);
    } else {
      if (
        opt?.removeEmptyObject &&
        isObject(obj[key]) &&
        isEmpty(obj[key])
      ) {
        delete obj[key];
      } else if (
        opt?.removeEmptyArray &&
        Array.isArray(obj[key]) &&
        obj[key].length === 0
      ) {
        delete obj[key];
      } else if (opt?.removeEmptyString && obj[key] === "") {
        delete obj[key];
      } else if (
        opt?.removeCeroValue &&
        isNumber(obj[key]) &&
        obj[key] === 0
      ) {
        delete obj[key];
      } else if (opt?.removeNullValue && isNull(obj[key])) {
        delete obj[key];
      } else if (opt?.removeUndefinedValue && isUndefined(obj[key])) {
        delete obj[key];
      } else if (
        opt?.removeFalseValue &&
        isBoolean(obj[key]) &&
        obj[key] === false
      ) {
        delete obj[key];
      } else if (opt?.removeNaNValue && isNaN(obj[key])) {
        delete obj[key];
      } else if (opt?.oneIsTrue && isNumber(obj[key]) && obj[key] === 1) {
        obj[key] = true;
      } else if (
        opt?.ceroIsFalse &&
        isNumber(obj[key]) &&
        obj[key] === 0
      ) {
        obj[key] = false;
      } else if (
        opt?.trueIsOne &&
        isBoolean(obj[key]) &&
        obj[key] === true
      ) {
        obj[key] = 1;
      } else if (
        opt?.falseIsCero &&
        isBoolean(obj[key]) &&
        obj[key] === false
      ) {
        obj[key] = 0;
      }
    }
  });

  return obj;
};

export default removeEmpty;
